import { RootPaths } from "@src/appV2/App/paths";

export const WORKLACE_QUIZ_BASE_PATH = "quiz/:shiftId";
export const WORKLACE_QUIZ_BASE_PATH_FULL = `${RootPaths.APP_V2_HOME}/${WORKLACE_QUIZ_BASE_PATH}`;

export const WORKPLACE_QUIZ_RULES_PATH = "rules";
export const WORKPLACE_QUIZ_RULES_PATH_FULL = `${RootPaths.APP_V2_HOME}/${WORKLACE_QUIZ_BASE_PATH}/${WORKPLACE_QUIZ_RULES_PATH}`;

export const WORKPLACE_QUIZ_QUESTION_PATH = "question";
export const WORKPLACE_QUIZ_QUESTION_PATH_FULL = `${RootPaths.APP_V2_HOME}/${WORKLACE_QUIZ_BASE_PATH}/${WORKPLACE_QUIZ_QUESTION_PATH}`;
